import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../auth/services/auth.service";
import { environment } from "../../../environments/environment";
import { SKIP_AUTH, USE_SESSION_TOKEN } from "../auth-context";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

  const authService = inject(AuthService);

  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  if (req.context.get(USE_SESSION_TOKEN)) {

    const newReq = req.clone({
      headers: req.headers.set('sessionToken', `${authService.getSessionToken()}`)
    });

    return next(newReq);
  }

  let tokenName = 'token';
  let token = authService.getSessionToken();

  if (req.url.startsWith(environment.apiUrl)) {
    tokenName = 'AuthorizationToken';
    token = authService.getAuthToken();
  }

  const newReq = req.clone({
    headers: req.headers.set(`${tokenName}`, `${token}`)
  });

  return next(newReq);
}